import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'urlMaker'
})
export class UrlMakerPipe implements PipeTransform {

  transform(id: string | number | null | undefined, itemName: string | null | undefined): string {
    const base = window.location.origin;
    switch (itemName) {
      case 'contact':
        return (id ? `${base}/contacts/${id}` : `${base}/contacts`);
      case 'organisation':
        return (id ? `${base}/organisations/${id}` : `${base}/organisations`);
      default:
        return (id ? `${base}` : `${base}`);
    }

  }


}
